var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBurgerMenu = function SvgBurgerMenu(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#burger-menu_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M18.75 5.352H1.25V3.71h17.5zm0 9.296H1.25v1.641h17.5zm0-5.468H1.25v1.64h17.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "burger-menu_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.25 1.25h17.5v17.5H1.25z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBurgerMenu);
export default ForwardRef;